var React = require('react');

function PlugNPlay (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: none;\n        stroke: #1d1d1b;\n        stroke-miterlimit: 10;\n        stroke-width: 1.8px;\n      }\n    ")),React.createElement("g",{"id":"Layer_1","data-name":"Layer 1","key":1},React.createElement("path",{"className":"cls-1","d":"M35.61,47.55v20.44c19.12,0,34.54-15.02,34.54-33.55S54.65.9,35.53.9.9,15.92.9,34.45c0,11.18,5.64,21.08,14.31,27.17M40.63,17.3v9.15M30.51,17.3v9.15M39.51,47.5h-7.54c-4.04,0-7.32-3.18-7.32-7.1v-13.94h22.19v13.94c0,3.92-3.28,7.1-7.33,7.1Z"}))]);
}

PlugNPlay.defaultProps = {"id":"Capa_2","data-name":"Capa 2","viewBox":"0 0 71.05 68.9"};

module.exports = PlugNPlay;

PlugNPlay.default = PlugNPlay;
